import gql from 'graphql-tag';
const STOP_DROP_AND_TYPE_ACTIVITY_FRAGMENT = gql `
  fragment StopDropAndTypeActivityFragment on StopDropAndTypeActivity {
    rounds {
      id
      title
      mainText {
        id
        elements
      }
      contentImage {
        id
        image {
          id
          src
        }
      }
      steps {
        id
        question
        answers {
          id
          answer
          isCorrect
        }
      }
    }
  }
`;
export default STOP_DROP_AND_TYPE_ACTIVITY_FRAGMENT;
